
namespace Areas.Inspections {
    "use strict";


    $(() => init());

    function init() {
        const button: DevExpress.ui.dxDropDownButton = $("#InspectionReportsDropDownButton").dxDropDownButton("instance");
        
        if (!button) return;

        const items = [
            { text: "Inspection Report", icon: "doc", action: Areas.Report.gotoInspectionReport },
            { text: "Inspection Report Multiple (40 max)", icon: "doc", action: Areas.Report.gotoInspectionReportMultiple },
            { text: "Inspection Report All", icon: "doc", action: Areas.Report.gotoInspectionReportAll }
        ];

        button.option("items", items);

        const button2: DevExpress.ui.dxDropDownButton = $("#InspectionInspectorDropDownButton").dxDropDownButton("instance");

        const items2 = [
            { text: "Assign Inspector", icon: "edit", action: gotoAssign },
            { text: "Deputy Inspector Review", icon: "edit", action: gotoDeputy },
            { text: "Write-Up by Inspector", icon: "edit", action: gotoWriteUp },
            { text: "Edit Attachments", icon: "edit", action: gotoInspectorEdit }
        ];

        button2.option("items", items2);
    }

    export function reportDropDownButtonClick(e) {
        e.itemData.action();
    }

    export function inspectorDropDownButtonClick(e) {
        e.itemData.action();
    }


}